import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

function OnSiteFilter() {
  const [searchParams, setSearchParams] = useSearchParams();

  const onSite = searchParams.get('onSite');

  return (
    <div className="w-max">
      <Stack spacing={2}>
        <Typography variant="body2">On Site</Typography>
        <div className="flex flex-col w-max">
          <RadioGroup
            defaultValue="all"
            value={onSite || 'all'}
            name="onsite-radio-buttons-group"
            id="onsite-radio-buttons-group"
            onChange={(event) => {
              setSearchParams((params) => {
                params.set('onSite', event.target.value);
                if (event.target.value === 'all') params.delete('onSite');
                return params;
              });
            }}
          >
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </div>
      </Stack>
    </div>
  );
}

export default OnSiteFilter;
